// extracted by mini-css-extract-plugin
module.exports = {"root":"WithDirtyDot_root__22tdr","dirty":"WithDirtyDot_dirty__15RIV","standaloneDirtyDot":"WithDirtyDot_standaloneDirtyDot__1dq_J"};